import formatContentSelectValue from './formatContentSelectValue'
const contentTypes = {
  capitulo: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'codigoProtheus',
    'tituloLivro',
    'autoresLivro',
    'copyrightLivro',
    'isbn',
    'edicaoLivro',
    'especialidadesLivro',
    'tituloSecao',
    'autoresSecao',
    'textoSecao',
    'document',
    'publicoAlvo',
    'grupoConteudo',
    'livroReferencia',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  tabela: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'codigoProtheus',
    'descricao',
    'tituloLivro',
    'autoresLivro',
    'autoresArtigo',
    'autoresDeT',
    'editoresDeT',
    'editoresArtigo',
    'copyrightLivro',
    'isbn',
    'edicaoLivro',
    'especialidadesLivro',
    'tituloSecao',
    'codigoCapitulo',
    'codigoArtigo',
    'codigoDeT',
    'autoresSecao',
    'textoSecao',
    'tipoOrigem',
    'tituloCapitulo',
    'tituloArtigo',
    'tituloDeT',
    'url',
    'publicoAlvo',
    'grupoConteudo',
    'origemId',
    'livroReferencia',
    'dataAtualizacao',
    'anoPublicacaoArtigo',
    'anoPublicacaoDeT',
    'minutosLeitura',
    'capituloReferencia',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  fluxograma: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'codigoProtheus',
    'descricao',
    'tituloLivro',
    'autoresLivro',
    'autoresArtigo',
    'autoresDeT',
    'editoresDeT',
    'editoresArtigo',
    'isbn',
    'copyrightLivro',
    'edicaoLivro',
    'especialidadesLivro',
    'tituloSecao',
    'autoresSecao',
    'codigoCapitulo',
    'codigoArtigo',
    'codigoDeT',
    'textoSecao',
    'tipoOrigem',
    'tituloCapitulo',
    'tituloArtigo',
    'tituloDeT',
    'url',
    'publicoAlvo',
    'grupoConteudo',
    'origemId',
    'livroReferencia',
    'dataAtualizacao',
    'anoPublicacaoArtigo',
    'anoPublicacaoDeT',
    'minutosLeitura',
    'capituloReferencia',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  figura: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'palavrasChave',
    'codigo',
    'codigoProtheus',
    'descricao',
    'tituloLivro',
    'autoresLivro',
    'autoresArtigo',
    'autoresDeT',
    'editoresDeT',
    'editoresArtigo',
    'copyrightLivro',
    'isbn',
    'edicaoLivro',
    'especialidadesLivro',
    'tituloSecao',
    'autoresSecao',
    'textoSecao',
    'tipoOrigem',
    'tituloCapitulo',
    'tituloArtigo',
    'tituloDeT',
    'idiomaCapitulo',
    'codigoCapitulo',
    'codigoArtigo',
    'codigoDeT',
    'url',
    'publicoAlvo',
    'grupoConteudo',
    'origemId',
    'livroReferencia',
    'dataAtualizacao',
    'anoPublicacaoArtigo',
    'anoPublicacaoDeT',
    'minutosLeitura',
    'capituloReferencia',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  medicamento: [
    'tipo',
    'autores',
    'editores',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigoProtheus',
    'tituloLivro',
    'especialidadesLivro',
    'edicaoLivro',
    'autoresLivro',
    'copyrightLivro',
    'isbn',
    'tituloSecao',
    'autoresSecao',
    'textoSecao',
    'document',
    'principioAtivo',
    'classificacaoTerapeutica',
    'publicoAlvo',
    'grupoConteudo',
    'livroReferencia',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  aula: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'tituloCurso',
    'autoresCurso',
    'copyrightCurso',
    'edicaoCurso',
    'codigoProtheus',
    'especialidadesCurso',
    'tituloModulo',
    'autoresModulo',
    'textoModulo',
    'descricao',
    'publicoAlvo',
    'grupoConteudo',
    'cursoReferencia',
    'codigoAula',
    'detalhesAula',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  webinar: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'tituloCurso',
    'autoresCurso',
    'copyrightCurso',
    'edicaoCurso',
    'codigoProtheus',
    'especialidadesCurso',
    'tituloModulo',
    'autoresModulo',
    'textoModulo',
    'descricao',
    'publicoAlvo',
    'grupoConteudo',
    'cursoReferencia',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  artigo: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'codigo',
    'isbn',
    'issn',
    'anoPublicacao',
    'dataAtualizacao',
    'palavrasChave',
    'codigoProtheus',
    'descricao',
    'document',
    'publicoAlvo',
    'grupoConteudo',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  podcast: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'tituloCurso',
    'autoresCurso',
    'copyrightCurso',
    'edicaoCurso',
    'codigoProtheus',
    'especialidadesCurso',
    'tituloModulo',
    'autoresModulo',
    'textoModulo',
    'especialidadesModulo',
    'copyrightModulo',
    'descricao',
    'publicoAlvo',
    'grupoConteudo',
    'cursoReferencia',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  diretriz: [
    'tipo',
    'titulo',
    'subtitulo',
    'autoresDiretriz',
    'instituicao',
    'codigo',
    'palavrasChave',
    'dataPublicacao',
    'document',
    'publicoAlvo',
    'grupoConteudo',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  consulta_rapida_e_recomendacoes: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'codigo',
    'codigoProtheus',
    'isbn',
    'issn',
    'anoPublicacao',
    'dataAtualizacao',
    'palavrasChave',
    'descricao',
    'document',
    'publicoAlvo',
    'grupoConteudo',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  diagnostico_e_tratamento: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'codigo',
    'codigoProtheus',
    'isbn',
    'issn',
    'anoPublicacao',
    'dataAtualizacao',
    'palavrasChave',
    'descricao',
    'document',
    'publicoAlvo',
    'grupoConteudo',
    'conteudoHtml',
    'buscaPalavrasChave',
    'buscaPeso'
  ],
  habilidades_clinicas: [
    'tipo',
    'titulo',
    'autores',
    'editores',
    'especialidades',
    'pesoDA',
    'idioma',
    'palavrasChave',
    'codigo',
    'tituloCurso',
    'autoresCurso',
    'copyrightCurso',
    'edicaoCurso',
    'codigoProtheus',
    'especialidadesCurso',
    'tituloModulo',
    'autoresModulo',
    'textoModulo',
    'descricao',
    'publicoAlvo',
    'grupoConteudo',
    'cursoReferencia',
    'codigoAula',
    'detalhesAula',
    'buscaPalavrasChave',
    'buscaPeso'
  ]
}

export const createFormData = (formFields, options = {}) => {
  const contentTypeFields = contentTypes[formFields.tipo]
  const data = new FormData()

  if (options.preview) {
    data.append('document', formFields['document'])
    return data
  }

  if ((contentTypeFields || []).length) {
    for (let field of contentTypeFields) {
      if (Array.isArray(formFields[field])) {
        const contentList = formatContentSelectValue(formFields[field]).map(item => {
          return item.value
        })

        data.append(field, JSON.stringify(contentList))
      } else {
        if (/fluxograma|figura|tabela/.test(formFields.tipo) && field === 'codigo') {
          formFields[field] && data.append(field, `${formFields[field]}`.toUpperCase())
        } else if (/Referencia/.test(field)) {
          const value = (formFields[field] || {}).value
          formFields[field] && data.append(field, `${value}`)
        } else if (/Id/.test(field)) {
          const value = (formFields[field] || {}).value
          formFields[field] && data.append(field, `${value}`)
        } else if (/detalhesAula/.test(field)) {
          data.append(field, formFields[field])
        } else {
          formFields[field] && data.append(field, formFields[field])
        }
      }
    }
  }
  return data
}



// WEBPACK FOOTER //
// ./src/utils/formatContentToSend.js